import React from 'react';
import { CenteredStack, JustifiedRow } from './styled/layout';
import { Box, Flex, Heading, Text } from 'rebass';
import { space } from '../theme';

export interface PageLayoutProps {
  title: string;
  subTitle?: string;
}

const PageActions: React.FC = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: ['space-between', 'space-between', 'flex-end'],
      '& > *:not(:last-child)': {
        mr: space.one,
      },
    }}
  >
    {children}
  </Box>
);

const PageHeader: React.FC<PageLayoutProps> = ({
  title,
  subTitle,
  children,
}) => (
  <Flex as={CenteredStack} mt={[space.one, space.one, space.six]} mb={30}>
    <JustifiedRow flexWrap={['wrap', 'wrap', 'nowrap']}>
      <Box sx={{ flexBasis: '100%' }} mb={[space.two, space.two, 0]}>
        <Heading as={'h1'}>{title}</Heading>
        {subTitle && (
          <Text mt={space.one} variant="bodyText">
            {subTitle}
          </Text>
        )}
      </Box>

      {children && <PageActions>{children}</PageActions>}
    </JustifiedRow>
  </Flex>
);

export { PageActions, PageHeader };
